<template>
  <div>
  <div id="update_p_m" v-if="permission" style="height: 40vh">

<div v-if="selectedOptions" class="score-compare-select-box">
  <div>
    <div class="score-compare-title"  >比赛名称：</div>
    <div>待完善：{{noTranslatedMatchNum}} / {{allMatchNum}}</div>
    <a-select style="width: 600px" :value="selectedOptions.selectedComp" @change="handleChangeComp">
<!--      <a-select-option value="-&#45;&#45;">请选择</a-select-option>-->
      <a-select-option
          v-for="comp in mlist_"
          :key="`score-select-comp-${comp.match_name}`"
          :value="comp.match_id">
        {{comp.match_name}}-{{comp.location}}-{{comp.match_eng_name}}
      </a-select-option>
    </a-select>
    <a-form
        layout="block"
        :model="formStateMatch"
        @finish="handleFinishMatch"
        @finishFailed="handleFinishFailedMatch"
    >
      <a-form-item >
        <!--      <span>12,WTT青年常规挑战赛,葡萄牙维拉雷亚尔,test_match_name</span>-->
        <a-input v-model="formStateMatch.matchEngName" style="width: 300px" placeholder="输入WTT中该比赛英文名">
        </a-input>
      </a-form-item>
      <div>
      <a-form-item>
        <a-button
            type="primary"
            html-type="submit"
            :disabled="formStateMatch.matchEngName === '' || formStateMatch.matchEngName === null"
            @click="update_match_name_(formStateMatch.matchEngName)"
        >
          update match info
        </a-button>
      </a-form-item>
      </div>
    </a-form>
  </div>
  <div>
    <div  class="score-compare-title"  >球员：</div>
    <div>待完善：{{noTranslatedPlayerNum}} / {{allPlayerNum}}</div>
    <a-select :value="selectedOptions.selectedPlayer" @change="handleChangePlayer">
      <a-select-option
          v-for="player in Object.values(plist_)"
          :key="`score-select-player-${player.player_id}`"
          :value="player.player_id">
        {{player.player_name}}-{{player.player_eng_name}}-{{player.player_wtt_id}}
      </a-select-option>
    </a-select>
    <a-form
        layout="block"
        :model="formStatePlayer"
        @finish="handleFinishPlayer"
        @finishFailed="handleFinishFailedPlayer"
    >
      <a-form-item >
        <!--        <span>player_name=徐晨皓&eng_name=test_p_name&wtt_id=999999</span>-->
        <a-input v-model="formStatePlayer.playerEngName" style="width: 300px" placeholder="输入WTT中该队员英文名">
        </a-input>

      </a-form-item>
      <div> 点击球员，新页面网址的末六位数字即为WTT_ID</div>
      <a-form-item>
        <a-input v-model="formStatePlayer.playerWTTId" style="width: 300px" placeholder="输入WTT中该队员WTT_ID">
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-button
            type="primary"
            html-type="submit"
            :disabled="formStatePlayer.playerEngName === '' || formStatePlayer.playerEngName === null||formStatePlayer.playerWTTId === '' || formStatePlayer.playerWTTId === null"
            @click="update_player_name_(formStatePlayer.playerEngName,formStatePlayer.playerWTTId)"
        >
          update player info
        </a-button>
      </a-form-item>
    </a-form>
  </div>


  </div>
    <div style="margin: 100px 100px 100px;">
      <a-form
          layout="inline"
          :model="formState"
          @finish="handleFinish"
          @finishFailed="handleFinishFailed"
      ><a-form-item>
        <a-button
            type="primary"
            html-type="submit"
            @click="force_load_event_db_()"
        >
          强制刷新数据
        </a-button>
      </a-form-item>
<!--        <a-form-item>-->
<!--          <a-button-->
<!--              type="primary"-->
<!--              html-type="submit"-->
<!--              @click="start_get_score_('all')"-->
<!--          >-->
<!--            更新所有比赛-->
<!--          </a-button>-->
<!--        </a-form-item>-->
        <a-form-item >
          <span style="user-select: text">例如:WTT Feeder Amman 2023 </span>
          <a-input v-model="formState.compName" style="width: 300px" placeholder="比赛英文名">

          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button
              type="primary"
              html-type="submit"
              :disabled="formState.compName === '' || formState.compName === null"
              @click="start_get_score_(formState.compName)"
          >
            更新单场比赛
          </a-button>
          <a-button
                    @click="()=>{this.$router.push('/add_sub_event')}"
                    style="border: 1px solid white;background-color: #000000;color: #FFFFFF;margin-left: 15px">
            手动新增比赛记录 </a-button>
        </a-form-item>
      </a-form>

      <!--  <a-button @click="start_get_score_()">start get score</a-button>-->
      <a-progress :percent="percentage"  />
      <p>{{hinder}}</p>
      <p></p>
      <p>更新单场比赛时，由于数据获取的不稳定性。如果三分钟以上进度条都不动，刷新此页面，重新输入比赛名，再次请求。已经请求到的数据不会丢失。</p>
<!--      <p>注意"更新所有比赛"慎点，不要在夜间点此按钮，此按钮一个小时只能点一次。</p>-->
    </div>
  </div>
    <div v-else >
      您无权限访问此界面
    </div>
  </div>
</template>

<script>
import {reactive} from "vue";
import {
  checkMaintainData, forceLoadEventDB,
  getTeamMatchesAll,
  getTeamPlayersAll,
  queryGetScore,
  startGetScore, startGetScoreByName,
  updateMatchEngName,
  updatePlayerEngName
} from "@/api";
import {message} from "ant-design-vue";
import utils from "@/utils/cardIcon";

export default {
  name: "UpdatePlayerMatchName",
  data(){
    return {
      permission:false,
      formStateMatch:reactive({
        matchEngName:''
      }),
      formStatePlayer:reactive({
        playerEngName:'',
        playerWTTId:''
      }),
      selectedOptions: {
        selectedComp:'',
        selectedPlayer:''
      },
      plist_:{},
      mlist_:[],
      percentage: 0,
      hinder:'',
      noTranslatedMatchNum:0,
      allMatchNum:0,
      noTranslatedPlayerNum:0,
      allPlayerNum:0,
      query_ttt: null,
      formState:reactive({
        compName:''
      })
    }
  },

  mounted() {
    this.checkPermissionMaintainData()
    this.getPlayerOptions().then( plist=>{
      this.getMatchesOptions().then(matchlist=>{
        // this.$store.commit('setTablePlayers', plist);
        // this.$store.commit('setTableCompetitions', matchlist)
        this.plist_=plist
        this.mlist_=matchlist
        this.allPlayerNum = plist.length
        this.allMatchNum = matchlist.length
        this.noTranslatedPlayerNum = plist.filter(r=>r.player_wtt_id===-1||r.player_wtt_id==='-1').length
        this.noTranslatedMatchNum = matchlist.filter(r=>r.match_eng_name==='not_translate').length
      })
    }
    )
  },
  methods:{

    handleFinish ( values)  {
      console.log(values, this.formState.compName);
    },
    handleFinishFailed ( errors)  {
      console.log(errors);
    },
    handleFinishMatch ( values)  {
      console.log(values, this.formStateMatch.matchEngName);
    },
    handleFinishFailedMatch ( errors)  {
      console.log(errors);
    },
    handleFinishPlayer ( values)  {
      console.log(values, this.formStatePlayer.playerEngName,this.formStatePlayer.playerWTTId);
    },
    handleFinishFailedPlayer ( errors)  {
      console.log(errors);
    },
    handleChangeComp(value) {
      this.selectedOptions.selectedComp = value
    },
    handleChangePlayer(value) {
      this.selectedOptions.selectedPlayer = value
    },
    async getPlayerOptions() {
      const response = await getTeamPlayersAll()
      if(response.status === 200) {
        // this.playerList = response.data.players.filter(r=>r.selected)
        // let rps = (response.data.players.filter(r=>r.selected))
        // console.log("plist len",rps.length)
        return response.data.players
      }
    },
    async getMatchesOptions() {
      const response = await getTeamMatchesAll()
      if(response.status === 200) {
        // let rps = response.data.matches.filter(r=>r.selected)
        // console.log("match len",rps.length)
        return response.data.matches.sort(utils.compareFnDate)
      }
    },
    update_match_name_(name){
      console.log(this.selectedOptions)
      if(this.selectedOptions.selectedComp){
        try{
          updateMatchEngName(this.selectedOptions.selectedComp,name).then(r=>message.info(r.data.message))
        }catch (e) {
          console.log(e)
        }
      }
    },
    update_player_name_(name,wtt_id){
      console.log(this.selectedOptions)
      if(this.selectedOptions.selectedPlayer){
        try{
          updatePlayerEngName(this.selectedOptions.selectedPlayer,name,wtt_id).then(r=>message.info(r.data.message))
        }catch (e) {
          console.log(e)
        }
      }
    },
    start_get_score_(name){
      this.start_get_score(name).then((suc)=>{
        if(suc) {
          this.query_ttt = setInterval(() => {
            try {
              this.query_get_score()
            } catch (e) {
              console.log(e)
            }
          }, 2000)
        }
      })

    },
    force_load_event_db_(){
      this.force_load_event_db().then(()=>{
        message.success('刷新成功')
      })
    },
    async force_load_event_db(){
      const response  = await forceLoadEventDB()
      if (response.status === 200) {
        if(response.data.success || response.data.success==='True' || response.data.success==='true'){

          return response.data.success
        }
      }
    },
    async start_get_score(name) {
      try{
        if(name==='all'){
          const response  = await startGetScore(name)
          if (response.status === 200) {
            if(response.data.success || response.data.success==='True' || response.data.success==='true'){
              this.$store.commit('setCToken',response.data.message)
              return response.data.success
            }
          }
        }else{
          const response  = await startGetScoreByName(name)
          if (response.status === 200) {
            if(response.data.success || response.data.success==='True' || response.data.success==='true'){
              this.$store.commit('setCToken',response.data.message)
              return response.data.success
            }
          }
        }


      }catch (e) {
        console.log(e)
      }
    },
    async checkPermissionMaintainData() {
      const response = await checkMaintainData()
      console.log(response.data)
      if (response.status === 200) {
        if(response.data.allow_maintain && response.data.allow_maintain==='yes'){
          this.permission=true
        }
      }
    },
    async query_get_score(){
      const response = await queryGetScore(this.$store.state.cToken)
      // console.log(response.data)
      if (response.status === 200) {
        this.percentage =  parseInt(response.data.progress);
        this.hinder = response.data.info
        if(this.percentage===100){
          clearInterval(this.query_ttt)
          // console.log('finish')
        }
      }
    },
  },

}
</script>


<style lang="less" scoped>
#update_p_m{
  position: absolute;
  z-index: 101;
  top: 5vh;
  height: calc(100% - 91px);
  width: calc(100% - 128px);
  margin-left: 64px;
  margin-right: 64px;
  background: white;
  //box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.5);
  border-radius: 6px;
  padding: 25px 40px 25px 40px;

  .score-compare-title {
    width: 100%;
    height: 24px;

    font-family: 'Lantinghei SC';
    font-style: normal;
    font-weight: 800;
    font-size: 24px;
    line-height: 24px;
    text-align: center;
    text-align: center;
    margin-bottom: 10px;
    letter-spacing: -0.015em;

    color: #000000;
  }

  .score-compare-select-box {
    width: 100%;
    height: 59px;
    display: inline;

    .score-compare-select {
      height: 35px;
      width: 580px;
      // margin-right: 135px;
      text-align: left;
      line-height: 35px;
      font-family: 'Lantinghei SC';
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      letter-spacing: -0.015em;
      color: #000000;
    }
    .score-compare-select:last-child {
      width: 435px;
    }

    /deep/ .ant-select {
      width: 325.52px;
      height: 35px;
      margin-left: 10px;
    }

    /deep/ .ant-calendar-picker {
      width: 153px;
      height: 35px;
    }
  }

  .score-compare-statistic-box {
    width: 100%;
    height: 155px;

    .score-compare-info {
      width: 100%;
      display: flex;
      margin-top: 10px;

      .info-box-player {
        width: 22%;
      }
      .info-box-score {
        width: 26%;
      }
    }
    .info-box-title {
      width: 100%;
      height: 50px;
      text-align: center;
      font-family: 'Lantinghei SC';
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 50px;
      letter-spacing: -0.015em;
      color: #000000;
      display: flex;

      .info-box-subtitle {
        width: 50%;
        text-align: center;
      }
    }
    .info-box-info {
      width: 100%;
      height: 35px;
      display: flex;

      .info-box-subinfo {
        width: 50%;
        text-align: center;
        font-family: 'DIN Alternate';
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 35px;
        text-align: center;
        letter-spacing: -0.015em;

        color: #00375B;
      }
    }
    .info-box-info[target=_border] {
      border-left: black 1px solid;
    }
    .member-info {
      text-overflow: ellipsis;
      height: 24px;
      white-space: nowrap;
      .flag {
        width: 30px;
        height: 20px;
        margin: 8px 0px;
        margin-right: 8%;
      }
      .icon {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        display: inline-block;
        object-fit: cover;
        object-position: top;
      }
      .member-name {
        margin-left: 8%;
        font-family: 'Lantinghei SC';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 35px;
        letter-spacing: -0.015em;
        color: #00375B;
      }
    }
  }

  .score-compare-list-box {
    height: calc(100% - 246px);

    .list-empty {
      width: 100%;
      height: calc(100% - 80px);
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .list-box {
      width: 100%;
      height: calc(100% - 80px);
      margin-top: 20px;
      padding: 2px;
      overflow-y: scroll;

      display: grid;
      justify-content: space-between;
      grid-template-columns: repeat(auto-fill, 560px);
      grid-template-rows: repeat(auto-fill, 160px);
      grid-row-gap: 21px;
    }
    // .list-box::-webkit-scrollbar {
    //   // display: none;
    // }
    .list-box-cell {
      width: 560px;
      height: 160px;
      margin-right: 5px;
    }
  }
  .score-compare-close-button {
    height: 53px;
  }
}
</style>
